import React, {Component} from 'react';
import PortfolioAccountClasification from "../components/tables/portfolioAccountClasification";
import PortfolioAccountClasificationGraph from "../charts/portfolioAccountClasificationGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {PERFORMANCE_ANALYSIS, PORTFOLIO_ACCOUNTS_CLASSIFICATION, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";

var Loader = require('react-loader');

class PortfolioAccountsClassificationComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(PERFORMANCE_ANALYSIS + cbu.checkBusinessUnit(this.props.bu) + PORTFOLIO_ACCOUNTS_CLASSIFICATION)
      .then((json) => {
        this.setState({data: json, loaded: true})
      });
  }

  render() {

    if (this.state.data.length > 0) {
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <PortfolioAccountClasification striped={true} data={this.state.data}/>
          <PortfolioAccountClasificationGraph data={this.state.data}/>
        </Loader>
      );
    } else {
      return (
        <Loader loaded={this.state.loaded} top="50%"><h2 className="without-avilable-information">{WHITOUT_INFORMATION}</h2>
        </Loader>);
    }
  }
}

export default PortfolioAccountsClassificationComponent;




// WEBPACK FOOTER //
// ./src/components/portfolioAccountsClassificationComponent.js